var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClinicalSecretary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.66,
    height: 30,
    fill: "#73a91b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1148 -789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5,0C55,0,55,0,55,27.5S55,55,27.5,55,0,55,0,27.5,0,0,27.5,0Z",
    transform: "translate(1148 789)",
    fill: "#eaf2dd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1162 801)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.494,24.525c0-3.014,3.319-5.489,5.882-5.979L6.324,24.223,8.7,24.107,9.239,30h.919c.836-1.7,1.81-3.931,2.336-4.958a52.8,52.8,0,0,1-3.3-6.873,8.154,8.154,0,0,1,1.081-.418,12.787,12.787,0,0,0-.055-2.9A9.375,9.375,0,0,1,8.957,6.782c1.452.888,4.05,1.8,7.989.813a4.253,4.253,0,0,1-2.164-1.722,3.809,3.809,0,0,1,2.8.591A9.33,9.33,0,0,1,16.427,14.9a12.624,12.624,0,0,0-.049,2.85,9.389,9.389,0,0,1,1.069.4L11.567,30H16.3l1.865-5.893,2.376.116-.619-5.407.027.008c2.976.721,5.221,3.172,5.221,5.7L25.155,30H26.66V24.525c0-3-2.4-5.886-5.688-6.961-1.611-2.388.3-5.33.2-9.719a7.846,7.846,0,0,0-15.692,0c-.107,4.354,1.678,7.27.2,9.653C2.92,18.582,0,21.22,0,24.525V30H1.494Z",
    transform: "translate(0 0)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.393,
    height: 1.403,
    transform: "translate(18.719 27.771)",
    fill: "#73a91b"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalSecretary);
export default __webpack_public_path__ + "static/media/Clinical-Secretary.9094e4f89ee93ec4c3f6829101c315c8.svg";
export { ForwardRef as ReactComponent };